import { render, staticRenderFns } from "./NivelLabel.vue?vue&type=template&id=44cdb9f2"
import script from "./NivelLabel.vue?vue&type=script&lang=js"
export * from "./NivelLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports